import { Common } from '~/models/common';

export namespace Messengers {
	export const collection = 'messengers';
	export const api = `/api/${collection}`;

	export type Model = Common.Model & {
		title: string | null;
		link: string;
		icon: 'social/telegram' | 'social/whatsapp' | 'social/max' | null;
	};

	export const modelState: Model = {
		...Common.modelState,
		id: 0,
		title: null,
		link: '',
		icon: null,
	};
}
